import CryptoJS from 'crypto-js';

/**
 * Convierte Base64URL a WordArray (necesario para compatibilidad con backend)
 */
function base64UrlToWordArray(base64url: string): CryptoJS.lib.WordArray {
  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4 !== 0) base64 += '=';
  return CryptoJS.enc.Base64.parse(base64);
}

/**
 * Convierte WordArray a Base64URL
 */
function wordArrayToBase64Url(wordArray: CryptoJS.lib.WordArray): string {
  return CryptoJS.enc.Base64.stringify(wordArray).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * Encripta una cadena con AES-256-CBC y padding PKCS7
 */
export function encrypt(data: string, aesKey: string): string {
  if (aesKey.length !== 32) {
    console.error('❌ La clave AES debe tener exactamente 32 caracteres.');
    throw new Error('Error al encriptar, el aesKey debe ser de 32 caracteres');
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(aesKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenar IV + Encrypted
    const combined = iv.clone().concat(encrypted.ciphertext);

    return wordArrayToBase64Url(combined);
  } catch (error) {
    console.error('❌ Error al encriptar:', error);
    throw new Error('Error al encriptar');
  }
}

/**
 * Desencripta una cadena encriptada con AES-256-CBC y padding PKCS7
 */
export function decrypt(encryptedData: string, aesKey: string): string {
  if (aesKey.length !== 32) {
    console.error('❌ La clave AES debe tener exactamente 32 caracteres.');
    throw new Error('Error al encriptar, el aesKey debe ser de 32 caracteres');
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(aesKey);
    const fullData = base64UrlToWordArray(encryptedData);

    const iv = CryptoJS.lib.WordArray.create(fullData.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(fullData.words.slice(4), fullData.sigBytes - 16);

    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('❌ Error al desencriptar:', error);
    throw new Error('Error al desencriptar');
  }
}
